var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.77995 0.507812C3.09995 0.507812 0.113281 3.49448 0.113281 7.17448C0.113281 10.8545 3.09995 13.8411 6.77995 13.8411C10.4599 13.8411 13.4466 10.8545 13.4466 7.17448C13.4466 3.49448 10.4599 0.507812 6.77995 0.507812ZM6.11328 10.5078V9.17448H7.44661V10.5078H6.11328ZM6.11328 3.84115V7.84115H7.44661V3.84115H6.11328Z",
    fill: "#B3261E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.43b90c447b3756239d65f5f632e933b9.svg";
export { ForwardRef as ReactComponent };